import React, {useEffect, useRef, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {
  removeItem,
  selectKP11SelectCartCentersNApps,
} from '../../../../../../app-store/kp11CartSlice'
import {
  CardPlanBodyStyle,
  CardPlanWebsiteUrlStyle,
  // CardPlanAddToCartStyle,
} from '../kp-11Link-catalog-cards-style'
// import {kpSuccessIcon} from '../../../../../../assets'
import {FloatingInput} from '../../../kp-11Link-reusable-components/kp-reusable-input'
import {CardPlanEntitlementsStyle} from '../../../kp-11Link-reusable-components/kp-plan-ent-checkbox-style'
import {EntCheckboxInput} from '../../../kp-11Link-reusable-components/kp-plan-ent-checkbox'
import {PlanRadioInput} from '../../../kp-11Link-reusable-components/kp-plan-radio-input'
import {CardPlanItemWrapStyle} from '../../../kp-11Link-reusable-components/kp-plan-radio-input-style'
import {
  buildCartEntity,
  getItemFromCart,
  isItemAtMaxQty,
  validateUrlLocally,
} from '../../../kp-11Link-utility/kp11-utility'
import {Button} from '@thryvlabs/maverick'
import {client} from '../../../../../../utils/api-client'
import {VALID_TLDS} from '../../../../../../utils/constants'
import {selectedLinkType} from '../../../../../../app-store/kpGlobalStateSlice'
import {selectEffectiveRole} from '../../../../../../app-store/selector'
// import {DELAY_HIDE_IN_SEC} from '../../../../../../utils/constants'
import {useAuth0} from '@auth0/auth0-react'
import {getUserRoles} from '../../../../../../utils/get-user-roles'

// plan website url
export const MCCardWebsiteUrlComponent = ({mcData, setMcData, required}) => {
  const lastInputTimeRef = useRef(null)
  const debounceTimerRef = useRef(null)
  const [extensionList, setExtensionList] = useState(VALID_TLDS)

  useEffect(() => {
    const fetchExtensionList = async () => {
      try {
        let response = await client(
          'keappartner/fetchConfigLookupValue/ValidUrlExtension',
        )

        if (response?.data[0]?.value) {
          setExtensionList(response?.data[0]?.value.split(','))
        }
      } catch (error) {
        console.error('Failed to fetch valid URL extensions:', error)
        // Keep using VALID_TLDS as fallback
      }
    }
    fetchExtensionList()
  }, [])

  const validateUrl = async domain => {
    if (!domain) return

    setMcData(prev => ({
      ...prev,
      loading: true,
      isError: false,
      helperText: '',
    }))

    // let response = await client(
    //   'keappartner/fetchConfigLookupValue/ValidUrlExtension',
    // )
    // let extentionList = VALID_TLDS
    // if (response?.data[0]?.value) {
    //   extentionList = response?.data[0]?.value.split(',')
    // }

    const localError = validateUrlLocally(domain, extensionList)

    if (!localError) {
      setMcData({
        mcDomain: domain,
        isMcDomainValidated: true,
        isError: false,
        helperText: '',
        loading: false,
      })
    } else {
      setMcData({
        isMcDomainValidated: false,
        isError: true,
        helperText: localError,
        loading: false,
      })
    }
  }

  // validation logic for length or delay
  useEffect(() => {
    if (!mcData?.mcDomain) {
      setMcData(prev => ({
        ...prev,
        isError: false,
        helperText: '',
        isMcDomainValidated: false,
      }))
      return
    }

    if (mcData?.isMcDomainValidated && !mcData?.isError) {
      return
    }

    clearTimeout(debounceTimerRef.current)

    const now = Date.now()
    lastInputTimeRef.current = now

    const domain = mcData?.mcDomain.trim()

    if (domain.length >= 8) {
      // Immediate validation for 8+ characters
      validateUrl(domain)
    } else {
      //  Delay validation for less than 8 characters
      debounceTimerRef.current = setTimeout(() => {
        const timeSinceLastInput = Date.now() - lastInputTimeRef.current
        if (timeSinceLastInput >= 5000 && domain.length < 8) {
          validateUrl(domain)
        }
      }, 5000)
    }

    return () => clearTimeout(debounceTimerRef.current)
  }, [mcData?.mcDomain])

  const handleBlur = () => {
    const domain = mcData?.mcDomain?.trim()

    // Check if value exists
    if (required && !domain) {
      setMcData({
        ...mcData,
        isError: true,
        helperText: 'Website URL is required',
        isMcDomainValidated: false,
      })
      return
    }

    validateUrl(domain)
  }

  return (
    <FloatingInput
      label="Enter Website URL"
      type="text"
      value={mcData?.mcDomain}
      onChange={e =>
        setMcData({
          mcDomain: e.target.value,
          isMcDomainValidated: false,
          isError: false,
          helperText: '',
        })
      }
      onBlur={handleBlur}
      isValid={mcData?.isMcDomainValidated}
      isError={mcData?.isError}
      helperText={mcData?.helperText}
      loading={mcData?.loading}
      required={required} // pass prop to input
    />
  )
}

// Catalog card component
export const KP11LinkMCCardComponent = ({
  selectedCountry = 'US',
  groupKey,
  items,
  onSelectItem,
  groupCustomFields,
  onGroupCustomFieldsUpdate,
  disabled,
  disabledItems = {},
  addedToCart,
}) => {
  const isMCPlanCode = code =>
    ['mc_plus-5-thryv-m2m', 'mc_pro-5-thryv-m2m'].includes(code)

  // Get selectedItem from Redux
  const cartCentersAndApps = useSelector(selectKP11SelectCartCentersNApps)
  const [selectedCard, setSelectedCard] = useState(null)
  const linkType = useSelector(selectedLinkType)
  const selectedItem = getItemFromCart({
    cartCentersAndApps,
    groupKey,
    items,
    predicate: item => isMCPlanCode(item?.code),
  })
  const {user} = useAuth0()
  const userRoles = getUserRoles(user)
  const effectiveRole = useSelector(selectEffectiveRole)
  const isInfluencerOps =
    (Array.isArray(effectiveRole) && effectiveRole.includes('InfluencerOps')) ||
    userRoles.includes('InfluencerOps')
  console.log('userRoles :: ', userRoles)

  let availableAddons =
    (selectedCard &&
      items.find(i => i.code === selectedCard?.code)?.entitlements) ||
    []
  if (linkType !== '1:1') {
    if (!isInfluencerOps) {
      availableAddons = availableAddons.filter(
        item => item.code !== 'ent-5-website',
      )
    }
  }
  const gmbEntitlement = availableAddons.find(ent => ent.code === 'ent-5-gmb')
  const gmbInCart =
    selectedItem?.addons?.some(a => a.code === 'ent-5-gmb') || false

  const dispatch = useDispatch()
  // const isItemAllreadyAddedandMcPro = items.find(
  //   item => item?.code === 'mc_pro-5-thryv-m2m' && item?.isAlreadyAdded,
  // )
  const isItemAlreadyAddedAndMcPro = items.some(
    item => item?.code === 'mc_pro-5-thryv-m2m' && item?.isAlreadyAdded,
  )

  // Check if the standalone "Professionally Designed Website" (addon-5-website_difm) is already in the cart
  const hasWebsiteDesignAddon = section =>
    (section || []).some(item => item?.code?.includes('addon-5-website_difm'))
  const isWebsiteDesignInCart =
    hasWebsiteDesignAddon(cartCentersAndApps?.apps) ||
    hasWebsiteDesignAddon(cartCentersAndApps?.centers) ||
    hasWebsiteDesignAddon(cartCentersAndApps?.oneTimeFees)

  const [mcData, setMcData] = useState({
    mcDomain: groupCustomFields?.mcDomain ?? '',
    isMcDomainValidated: groupCustomFields?.isMcDomainValidated ?? false,
    isError: groupCustomFields?.isError ?? false,
    helperText: groupCustomFields?.helperText ?? '',
    loading: groupCustomFields?.loading ?? false,
  })
  const [pendingAddons, setPendingAddons] = useState([])

  const setPartialMcData = partial => {
    setMcData(prev => ({...prev, ...partial}))
  }

  const mergeAddonsByCode = addons => {
    const seenCodes = new Set()

    return addons.filter(addon => {
      if (!addon?.code || seenCodes.has(addon.code)) {
        return false
      }

      seenCodes.add(addon.code)
      return true
    })
  }

  const formatItem = item => {
    const baseData = {
      code: item.code,
      name: item.name,
      id: item.id,
      prodType: item?.prod_type,
      quantity: 1,
      unitAmount: 0,
      amount: 0,
    }
    return baseData
  }

  useEffect(() => {
    // if (mcData.isWebsiteURLValidated) {
    onGroupCustomFieldsUpdate(mcData)
    // }
  }, [mcData.mcDomain, mcData.isMcDomainValidated])

  useEffect(() => {
    if (!selectedCard?.code) {
      setPendingAddons([])
      return
    }

    const selectedCardEntitlements =
      items.find(i => i.code === selectedCard?.code)?.entitlements || []
    const defaultAddons = gmbEntitlement ? [formatItem(gmbEntitlement)] : []
    const carriedAddons =
      selectedItem?.code && selectedItem.code !== selectedCard.code
        ? (selectedItem.addons || []).filter(addon =>
            selectedCardEntitlements.some(ent => ent.code === addon.code),
          )
        : []

    setPendingAddons(mergeAddonsByCode([...defaultAddons, ...carriedAddons]))
  }, [
    gmbEntitlement,
    items,
    selectedCard?.code,
    selectedItem?.addons,
    selectedItem?.code,
  ])

  useEffect(() => {
    if (!selectedItem?.code) return
    setPendingAddons([])
  }, [selectedItem?.code])

  useEffect(() => {
    if (selectedItem?.code && selectedCard?.code !== selectedItem?.code) {
      setSelectedCard(selectedItem)
    }
  }, [selectedItem?.code])

  // const [add2CartBannerStatus, setAdd2BannerStatus] = useState(addedToCart)
  // useEffect(() => {
  //   if (addedToCart) {
  //     setAdd2BannerStatus(true)
  //     setTimeout(() => {
  //       setAdd2BannerStatus(false)
  //     }, DELAY_HIDE_IN_SEC * 1000)
  //   }
  // }, [addedToCart])
  const isPlanDisabled = (disabled, selectedItem, item, mcData) => {
    const isItemAllreadyAdded = item?.isAlreadyAdded

    let isdisabled =
      disabled ||
      disabledItems[item?.code] ||
      isItemAllreadyAdded ||
      isItemAlreadyAddedAndMcPro
    if (linkType === '1:1') {
      isdisabled = isdisabled || !mcData?.isMcDomainValidated
    }
    return isdisabled
  }

  const effectiveSelectedCard = selectedCard || selectedItem
  const isSelectedMCPlan = isMCPlanCode(effectiveSelectedCard?.code)
  const isSwitchingPlans =
    !!selectedItem?.code &&
    !!selectedCard?.code &&
    selectedItem.code !== selectedCard.code
  let isAddToCartDisabled = !isSelectedMCPlan
  if (linkType === '1:1') {
    isAddToCartDisabled = !mcData?.isMcDomainValidated || isAddToCartDisabled
  }
  const selectedCardMaxQtyReached = isItemAtMaxQty({
    cartCentersAndApps,
    item: selectedCard,
  })
  isAddToCartDisabled = isAddToCartDisabled || selectedCardMaxQtyReached

  return (
    <>
      <CardPlanBodyStyle>
        {linkType === '1:1' && (
          <CardPlanWebsiteUrlStyle>
            <MCCardWebsiteUrlComponent
              mcData={mcData}
              setMcData={setPartialMcData}
              required={true}
            />
          </CardPlanWebsiteUrlStyle>
        )}
        <div className="card-plan-subText">Select a subscription plan</div>
        <CardPlanItemWrapStyle wrap column={true}>
          {items.map(item => (
            <PlanRadioInput
              key={item.code}
              checked={selectedCard?.code === item.code}
              item={item}
              disabled={isPlanDisabled(disabled, selectedItem, item, mcData)}
              onChange={() => {
                setSelectedCard(item)
                // const updatedItem = buildCartEntity({
                //   kind: 'item',
                //   source: {...item, groupKey, section: 'centers'},
                //   selectedCountry,
                //   quantity: 1,
                //   previousItem: selectedItem,
                //   keepAddons: true,
                //   autoAdd: 'GMB',
                // })
                // onSelectItem(updatedItem)
              }}
              country={selectedCountry}
            />
          ))}
        </CardPlanItemWrapStyle>

        {/* Addons (entitlements) in checkbox */}
        {availableAddons.length > 0 && (
          <CardPlanEntitlementsStyle>
            {availableAddons.map(ent => {
              const isAutoSelectedWebsite =
                ent.code === 'ent-5-website' && isWebsiteDesignInCart
              const isDefaultGMB = ent.code === 'ent-5-gmb'
              const isGmbDisabled = isDefaultGMB // && !selectedItem?.code
              const effectiveAddons =
                isSwitchingPlans || !selectedItem?.code
                  ? pendingAddons
                  : selectedItem?.addons || []
              const isGmbChecked = isDefaultGMB
                ? !isSwitchingPlans && selectedItem?.code
                  ? gmbInCart
                  : pendingAddons.some(a => a.code === ent.code)
                : false
              return (
                <EntCheckboxInput
                  key={ent.code}
                  checked={
                    isAutoSelectedWebsite ||
                    isGmbChecked ||
                    effectiveAddons?.some(a => a.code === ent.code) ||
                    false
                  }
                  label={ent.name}
                  disabled={
                    isAutoSelectedWebsite ||
                    isGmbDisabled ||
                    ent?.disabled ||
                    ent?.isAlreadyAdded ||
                    (linkType === '1:1' && !mcData?.isMcDomainValidated)
                  }
                  onChange={() => {
                    if (isGmbDisabled) return
                    if (!selectedItem?.code || isSwitchingPlans) {
                      setPendingAddons(prev => {
                        const exists = prev.some(a => a.code === ent.code)
                        return exists
                          ? prev.filter(a => a.code !== ent.code)
                          : [...prev, ent]
                      })
                      return
                    }
                  }}
                />
              )
            })}
          </CardPlanEntitlementsStyle>
        )}

        <div className="d-flex w-100 justify-content-center">
          <Button
            variant="primary"
            disabled={isAddToCartDisabled}
            onClick={() => {
              if (selectedItem) {
                if (selectedItem?.code === selectedCard?.code) {
                  return
                } else {
                  dispatch(removeItem({groupKey}))
                }
              }
              const updatedItem = buildCartEntity({
                kind: 'item',
                source: {...selectedCard, groupKey, section: 'centers'},
                selectedCountry,
                quantity: 1,
                previousItem: selectedItem,
                keepAddons: true,
                autoAdd: 'GMB',
                customFields: {mcDomain: mcData.mcDomain},
              })
              if (
                (isSwitchingPlans || !selectedItem?.code) &&
                pendingAddons.length > 0
              ) {
                let nextAddons = [...pendingAddons]

                if (isWebsiteDesignInCart) {
                  const mcProWebsiteAddon = selectedCard?.entitlements?.find(
                    e => e.code === 'ent-5-website',
                  )

                  if (mcProWebsiteAddon) {
                    const websiteAddon = buildCartEntity({
                      kind: 'addon',
                      source: mcProWebsiteAddon,
                      selectedCountry,
                    })
                    nextAddons = mergeAddonsByCode([
                      ...nextAddons,
                      websiteAddon,
                    ])
                  }
                }

                updatedItem.addons = nextAddons
              }
              onSelectItem(updatedItem)
            }}
          >
            Add to Cart
          </Button>
        </div>
      </CardPlanBodyStyle>
    </>
  )
}
